import React, { useContext, useState } from "react";
import { FaEye, FaRegHeart, FaRegStar, FaStar } from "react-icons/fa";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Slide,
} from "@mui/material";

// Composant de transition pour l'animation slide-up
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Card = ({ articles }) => {
  const { cart, addToCart } = useContext(CartContext);
  const [quantity, setQuantity] = useState(1);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  const handleAddToCart = () => {
    const newItem = { ...articles, quantity };

    // Ajouter le produit au panier via le contexte
    addToCart(newItem);

    // Ouvrir le dialog au lieu de la snackbar
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const findCartItem = () => {
    return cart.find((item) => item?._id === articles?._id);
  };

  return (
    <>
      <div className="showcase bg-white h-[330px] w-[90%] shadow-xl ">
        <div className="showcase-banner">
          <img
            src={articles.imageUrls[0]}
            alt={articles.name}
            width={300}
            height={300}
            className="object-cover w-[100%] h-[150px]"
            onClick={() => {
              navigate(`/details/${articles._id}`);
              window.scrollTo(0, 0);
            }}
          />
          {articles.discount.applyDiscount === true && (
            <p className="showcase-badge">
              -{articles.discount.percentDiscount}%
            </p>
          )}

          <div className="showcase-actions">
            <button
              className="btn-action"
              onClick={() => {
                navigate(`/details/${articles._id}`);
                window.scrollTo(0, 0);
              }}
            >
              <FaEye />
            </button>
            <button className="btn-action" onClick={handleAddToCart}>
              <MdOutlineAddShoppingCart />
            </button>
          </div>
        </div>

        <div className="showcase-content ">
          <Link
            className="showcase-category line-clamp-1"
            to={`/details/${articles._id}`}
          >
            {articles.name}
          </Link>
          <Link to={`/details/${articles._id}`}>
            <h3 className="showcase-title line-clamp-1">
              {articles.description}
            </h3>
          </Link>

          <div className="price-box">
            {articles.discount.applyDiscount === true ? (
              <>
                <p className="price text-xs">
                  {articles.discount.newPrice} FCFA
                </p>
                <del className="text-xs">{articles.price} FCFA</del>
              </>
            ) : (
              <p className="price text-xs">{articles.price} FCFA</p>
            )}
          </div>

          {/* Bouton Ajouter au panier */}
          {findCartItem() ? (
            <button
              onClick={handleAddToCart}
              className="mt-1 bg-primary cursor-default text-white text-sm bg-orange-500 p-1 font-semibold rounded transition-all mb-1"
            >
              Article ajouté
            </button>
          ) : (
            <button
              onClick={handleAddToCart}
              className="mt-1 bg-primary text-orange-500 bg-white font-semibold text-sm p-1 rounded hover:bg-gray-50 hover:text-orange-400  transition-all mb-1"
            >
              Ajouter au panier
            </button>
          )}
        </div>
      </div>

      {/* Dialog de confirmation au lieu de la Snackbar */}
      <Dialog
        open={dialogOpen}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleCloseDialog}
        aria-describedby="add-to-cart-dialog-description"
      >
        <DialogTitle>{"Produit ajouté au panier"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="add-to-cart-dialog-description">
            <strong className="text-[#FF8624]">{articles.name}</strong> a été
            ajouté avec succès à votre panier !
            <br />
            Quantité : {quantity}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={handleCloseDialog}
            className="text-white text-center p-2 rounded-lg shadow-lg bg-[#FF8624] hover:bg-orange-400 transition-all"
          >
            Continuer mes achats
          </button>
          <button
            onClick={() => {
              handleCloseDialog();
              navigate("/cart");
            }}
            className="text-white text-center p-2 rounded-lg shadow-lg bg-[#FF8624] hover:bg-orange-400 transition-all"
          >
            Voir le panier
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Card;
